import { AlertTriangle, Globe } from 'lucide-react';
import { Button } from '../components/ui/button';

/**
 * Undefined Domain Error Page
 * Shown when a domain is not registered in the system
 */
const UndefinedDomain = ({ domain }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-red-900 to-slate-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* Icon */}
        <div className="mb-8">
          <div className="w-24 h-24 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6 animate-pulse">
            <AlertTriangle className="w-12 h-12 text-red-400" />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-white mb-4">
          Tanımsız Domain
        </h1>

        {/* Description */}
        <p className="text-slate-300 mb-6 leading-relaxed">
          Bu domain (<span className="font-mono text-red-400">{domain}</span>) sistemde kayıtlı değil.
          Lütfen doğru domain adresini kullandığınızdan emin olun.
        </p>

        {/* Domain Info Card */}
        <div className="bg-slate-800/50 rounded-xl p-6 mb-8 border border-slate-700">
          <div className="flex items-center justify-center gap-2 text-slate-400 mb-4">
            <Globe className="w-5 h-5" />
            <span className="text-sm">Erişmeye çalıştığınız domain</span>
          </div>
          <div className="font-mono text-lg text-white bg-slate-900/50 rounded-lg py-3 px-4">
            {domain}
          </div>
        </div>

        {/* Instructions */}
        <div className="text-left bg-slate-800/30 rounded-lg p-4 mb-8 border border-slate-700/50">
          <h3 className="text-white font-semibold mb-3">Ne yapmalısınız?</h3>
          <ul className="space-y-2 text-slate-400 text-sm">
            <li className="flex items-start gap-2">
              <span className="text-red-400 mt-1">•</span>
              <span>Domain adresinin doğru yazıldığından emin olun</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-red-400 mt-1">•</span>
              <span>Firma yöneticinizle iletişime geçin</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-red-400 mt-1">•</span>
              <span>Domain henüz sisteme eklenmemiş olabilir</span>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <p className="text-slate-500 dark:text-slate-400 text-sm">
          Teknik destek için:{' '}
          <a href="mailto:support@hrportal.be" className="text-blue-400 hover:underline">
            support@hrportal.be
          </a>
        </p>
      </div>
    </div>
  );
};

export default UndefinedDomain;
